
/**
 * Tracks a Google auth event with specific parameters
 */
export const trackGoogleAuth = (action: 'start' | 'success' | 'error', details?: any) => {
  try {
    console.log(`[Auth Tracking] Google Auth ${action}`, details);
    
    if (window.gtag) {
      window.gtag('event', `google_auth_${action}`, {
        event_category: 'Authentication',
        event_label: details ? JSON.stringify(details) : undefined,
      });
      
      // For successful Google auth conversions, track as conversion event
      if (action === 'success') {
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17101682215/6cu0COyi9vQYEMGivJo713',
        });
        console.log('[Auth Tracking] Google Auth conversion tracked');
      }
    }
    
  } catch (error) {
    console.error('[Auth Tracking] Error tracking auth event:', error);
  }
};

/**
 * Tracks a LinkedIn auth event with specific parameters
 */
export const trackLinkedInAuth = (action: 'start' | 'success' | 'error', details?: any) => {
  try {
    console.log(`[Auth Tracking] LinkedIn Auth ${action}`, details);
    
    if (window.gtag) {
      window.gtag('event', `linkedin_auth_${action}`, {
        event_category: 'Authentication',
        event_label: details ? JSON.stringify(details) : undefined,
      });
      
      // For successful LinkedIn auth conversions, track as conversion event
      if (action === 'success') {
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17101682215/6cu0COyi9vQYEMGivJo713',
        });
        console.log('[Auth Tracking] LinkedIn Auth conversion tracked');
      }
    }
    
  } catch (error) {
    console.error('[Auth Tracking] Error tracking auth event:', error);
  }
};
